import { Injectable } from "@angular/core";
import { DbDaoBase } from "../../../../../gyzmo-commons/dao/db/base/db.dao.base";
import { isNullOrEmpty } from "../../../../../gyzmo-commons/helpers/null.helper";
import { AppSqlProvider } from "../../../../../gyzmo-commons/persistence/app.sql.provider";
import { LoggerService } from "../../../../../gyzmo-commons/services/logs/logger.service";
import { GroupCategory } from "../../../../models/inspection/common/groupCategory.model";

@Injectable({
    providedIn: "root",
})
export class GroupCategoryDbDao extends DbDaoBase<GroupCategory> {
    constructor(
        logger: LoggerService,
        private sqlProvider: AppSqlProvider,
    ) {
        super(logger);
    }

    public async createIndexes(): Promise<void> {
        // Implémentation des index si nécessaire
    }

    public createTable(): Promise<void> {
        const query = `
            CREATE TABLE IF NOT EXISTS ${ GroupCategory.TABLENAME } (
                id TEXT PRIMARY KEY,
                wording TEXT,
                _order TEXT
            );
        `;
        return this.sqlProvider.query(query, [])
            .then(async () => {
                await this.createIndexes();
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    delete(id: string): Promise<any> {
        const query = `DELETE FROM ${ GroupCategory.TABLENAME } WHERE id = ?;`;
        return this.sqlProvider.query(query, [id]);
    }

    deleteAll(): Promise<any> {
        const query = `DELETE FROM ${ GroupCategory.TABLENAME };`;
        return this.sqlProvider.query(query, []);
    }

    public get(id: string, hydrate: boolean = false): Promise<GroupCategory> {
        if (isNullOrEmpty(id)) {
            return Promise.resolve(null);
        }
        const query = `SELECT * FROM ${ GroupCategory.TABLENAME } WHERE id = ?;`;
        return this.sqlProvider.query(query, [id])
            .then(data => {
                if (data.rows.length <= 0) {
                    return null;
                }
                const groupCategory: GroupCategory = this.rowToModel(data.rows[0]);
                const hydratationPromises = [];
                return Promise.all(hydratationPromises)
                    .then(() => {
                        return groupCategory;
                    });
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    public getTableName(): string {
        return GroupCategory.TABLENAME;
    }

    protected rowToModel(row: any): GroupCategory {
        const groupCategory = new GroupCategory();
        groupCategory.id = row.id;
        groupCategory.wording = row.wording;
        groupCategory.order = row._order;
        return groupCategory;
    }

    public save(groupCategory: GroupCategory): Promise<GroupCategory> {
        const query = `
            INSERT OR REPLACE INTO ${ GroupCategory.TABLENAME } (id, wording, _order)
            VALUES (?, ?, ?);
        `;
        const values = [
            groupCategory.id,
            groupCategory.wording,
            groupCategory.order,
        ];
        return this.sqlProvider.query(query, values)
            .then(() => {
                return groupCategory;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }
}
